import { render, staticRenderFns } from "./StoreVideo.vue?vue&type=template&id=953d86ba&scoped=true&"
import script from "./StoreVideo.vue?vue&type=script&lang=js&"
export * from "./StoreVideo.vue?vue&type=script&lang=js&"
import style0 from "./StoreVideo.vue?vue&type=style&index=0&id=953d86ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953d86ba",
  null
  
)

export default component.exports